import { Button, Input, message, Switch } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import axios from '../../util/Api';
import { Form, useFormik } from 'formik';
import React, { useState } from 'react';
import Item from '../../components/Form/Item';
import { useHistory } from 'react-router-dom';

const Edit = ({ skill }) => {
  const history = useHistory();
  const formik = useFormik({
    initialValues: {
      name: skill.name,
      active: skill.status.is_active
    },
    onSubmit: (values, actions) => {
      const url = `/skills/update?id=${skill.id}`;
      const data = { ...values };
      axios.post(url, data).then(resp => {
        if (resp.data.success) {
          message.success("Kompetensi berhasil diperbarui");
          setIsModalVisible(false);
          actions.setSubmitting(false);
          history.push(`/skills`);
        } else {
          message.error("Gagal memperbarui Kompetensi");
        }
      }).catch(err => {
        message.error("Gagal memperbarui Kompetensi");
      });
    }
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  
  const handleOk = () => {
    formik.submitForm();
  }
  const handleCancel = () => {
    setIsModalVisible(false);
  }

  return (
    <div className="gx-text-right">
      <Button type="default" size="small" onClick={() => setIsModalVisible(true)}>Edit</Button>
      <Modal
        closable={false}
        title="Edit Kompetensi"
        visible={isModalVisible}
        onOk={handleOk}
        okText="Simpan Perubahan"
        onCancel={handleCancel}
        cancelText="Batal"
        confirmLoading={formik.isSubmitting}
      >
        <form onSubmit={formik.handleSubmit}>
          <Item name="Deskripsi">
            <Input autoFocus name="name" value={formik.values.name} onChange={formik.handleChange} />
          </Item>
          <Item name="Status">
            <Switch
              checkedChildren="Active"
              unCheckedChildren="Inactive"
              defaultChecked={formik.values.active}
              onChange={(e) => formik.setFieldValue("active", e)}
            />
          </Item>
        </form>
      </Modal>
    </div>
  );
}

export default Edit;